module.exports = __webpack_public_path__ + "static/media/05.bec47fd6.png";